import type { PageInfo } from './types';

type CursorSource = {
  cursor?: string | null;
  next_page_token?: string;
  is_truncated?: boolean;
};

export function normalizeCursor(source: CursorSource): PageInfo {
  const cursor = source.cursor ?? source.next_page_token ?? null;
  const hasMore =
    typeof source.is_truncated === 'boolean'
      ? source.is_truncated
      : Boolean(cursor);
  return {
    cursor,
    has_more: hasMore,
    is_truncated: source.is_truncated,
    next_page_token: source.next_page_token,
  };
}
